import { Tabs, Tooltip } from 'flowbite';
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css/bundle';

const scrollTrigger = 20;
const changeColorTrigger = screen.height - 280;

const navbar = document.getElementById('main-navbar');
const topbar = document.getElementById('main-topbar');

window.makeNavbarDark = () => {
  navbar.classList.add('dark');
  navbar.classList.remove('light');
  try {
    document.getElementById('nav-left-logo').classList.add('hidden');
    document.getElementById('nav-left-logo-light').classList.remove('hidden');
  } catch (e) {}
};

window.makeNavbarLight = () => {
  navbar.classList.remove('dark');
  navbar.classList.add('light');
  try {
    document.getElementById('nav-left-logo').classList.remove('hidden');
    document.getElementById('nav-left-logo-light').classList.add('hidden');
  } catch (e) {}
};

window.makeTopbarDark = () => {
  if (!topbar) {
    return;
  }
  topbar.classList.add('dark');
  topbar.classList.remove('light');
};

window.makeTopbarLight = () => {
  if (!topbar) {
    return;
  }
  topbar.classList.remove('dark');
  topbar.classList.add('light');
};

window.hamburger = false;

window.addEventListener('DOMContentLoaded', () => {
  if (window.scrollY >= scrollTrigger || window.pageYOffset >= scrollTrigger) {
    window.makeNavbarLight();
  } else if (!window.hamburger) {
    window.makeNavbarDark();
  }
});

let mobileCounted = false;
let lastScrollTop;
const setNavbarTop = function (event) {
  const bannerWrapper = document.getElementById('message-wrapper-sticky');
  navbar.style.top = bannerWrapper ? bannerWrapper.offsetHeight + 'px' : '0';
};
window.onscroll = function () {
  let bannerWrapper = document.getElementById('message-wrapper-sticky');
  // We add pageYOffset for compatibility with IE.
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  if (window.scrollY >= scrollTrigger || window.pageYOffset >= scrollTrigger) {
    if (scrollTop > lastScrollTop && !window.hamburger) {
      navbar.style.top = '-80px';
      for (const dropdown of document.querySelectorAll(
        '#main-navbar .dropdown-content',
      )) {
        dropdown.classList.add('hidden');
      }
    } else {
      navbar.style.top = bannerWrapper
        ? bannerWrapper.offsetHeight + 'px'
        : '0';
      for (const dropdown of document.querySelectorAll(
        '#main-navbar .dropdown-content',
      )) {
        dropdown.classList.remove('hidden');
      }
      if (window.scrollY >= changeColorTrigger) {
        window.makeNavbarLight();
      } else {
        window.makeNavbarDark();
      }
    }
  } else {
    window.makeNavbarDark();
  }

  if (window.scrollY >= changeColorTrigger) {
    window.makeTopbarLight();
  } else {
    window.makeTopbarDark();
  }

  lastScrollTop = scrollTop;
  let mobileCounter = document.getElementById('mobile-counter');
  if (
    window.scrollY >= mobileCounter.getBoundingClientRect().top ||
    window.pageYOffset >= mobileCounter.getBoundingClientRect().top
  ) {
    if (!mobileCounted) {
      counterAnim(
        '#mobile-counter-1',
        0,
        window['home_page_stats']['students_count'],
        2000,
        document.dir === 'ltr' ? ',' : '٬',
      );
      counterAnim(
        '#mobile-counter-2',
        0,
        window['home_page_stats']['teachers_count'],
        3000,
        document.dir === 'ltr' ? ',' : '٬',
      );
      counterAnim(
        '#mobile-counter-3',
        0,
        window['home_page_stats']['class_hours'],
        4000,
        document.dir === 'ltr' ? ',' : '٬',
      );
      counterAnim(
        '#mobile-counter-4',
        0,
        window['home_page_stats']['submissions_count'],
        5000,
        document.dir === 'ltr' ? ',' : '٬',
      );
    }
    mobileCounted = true;
  }
};

new Swiper('.review-slider-content', {
  modules: [Navigation, Pagination],
  slidesPerView: 3,
  spaceBetween: 24,
  centeredSlides: true,
  loop: true,
  fade: true,
  grabCursor: true,
  pagination: {
    el: '.review-swiper-pagination',
    clickable: 'true',
  },
  navigation: {
    nextEl: '.review-swiper-button-prev',
    prevEl: '.review-swiper-button-next',
  },

  breakpoints: {
    0: {
      slidesPerView: 'auto',
      spaceBetween: 0,
    },
    950: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
  },
});

const featuresSwiper = new Swiper('.feature-slider-content', {
  modules: [Autoplay, EffectFade],
  slidesPerView: 'auto',
  spaceBetween: 0,
  loop: 'true',
  centerSlide: false,
  effect: 'fade',
  fadeEffect: { crossFade: true },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
});

new Swiper('.blog-swiper', {
  modules: [Navigation],
  spaceBetween: 20,
  grabCursor: true,
  navigation: {
    nextEl: '.blog-swiper-button-prev',
    prevEl: '.blog-swiper-button-next',
  },
  breakpoints: {
    0: {
      slidesPerView: 'auto',
      spaceBetween: 0,
    },
    950: {
      slidesPerView: 'auto',
      spaceBetween: 32,
    },
  },
});

new IntersectionObserver((entries, observer) => {
  if (entries[0].isIntersecting) {
    featuresSwiper.slideToLoop(0);
  }
}).observe(document.querySelector('#feature-slider'));

const enableFeature = (index) => {
  try {
    let featureComponents =
      document.getElementsByClassName('feature-component');
    for (const component of featureComponents) {
      component.classList.remove('active');
      component.getElementsByClassName('feature-progress-bar')[0].style.height =
        '0%';
    }
    let selected = featureComponents[index];
    selected.className += ' active';
  } catch (e) {}

  try {
    let mobileFeatureComponents = document.getElementsByClassName(
      'mobile-feature-component',
    );
    let mobileFeatureProgresses = document.getElementsByClassName(
      'mobile-feature-progress',
    );

    for (const mobileComponent of mobileFeatureComponents) {
      mobileComponent.classList.remove('block');
      mobileComponent.classList.add('hidden');
    }
    for (const progress of mobileFeatureProgresses) {
      progress.getElementsByClassName(
        'mobile-feature-progress-bar',
      )[0].style.width = '0%';
    }

    let mobileSelected = mobileFeatureComponents[index];
    mobileSelected.className += 'block';
  } catch (e) {}

  try {
    let featureLotties = document.getElementsByClassName('feature-lottie');
  } catch (e) {}
};

window.setActiveFeature = (index) => {
  featuresSwiper.slideToLoop(index);
};
featuresSwiper.on('slideChange', function (swiper) {
  enableFeature(swiper.realIndex);
});

const setFeatureProgress = (index, percentage) => {
  let featureComponents = document.getElementsByClassName('feature-component');
  let mobileFeatureComponents = document.getElementsByClassName(
    'mobile-feature-progress',
  );
  const progressBar = featureComponents[index].querySelector(
    '.feature-progress-bar',
  );
  const mobileProgressBar = mobileFeatureComponents[index].querySelector(
    '.mobile-feature-progress-bar',
  );
  progressBar.style.height = 100 - percentage * 100 + '%';
  mobileProgressBar.style.width = 100 - percentage * 100 + '%';
};

featuresSwiper.on('autoplayTimeLeft', function (swiper, timeLeft, percentage) {
  setFeatureProgress(swiper.realIndex, percentage);
});

var schoolIconsSwiper = new Swiper('.school-icon-slider-content', {
  modules: [Autoplay],
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 64,
  speed: 5000,
  autoplay: {
    delay: 1,
    disableOnInteraction: false,
  },
  breakpoints: {
    0: {
      slidesPerView: 'auto',
      spaceBetween: 8,
    },
    500: {
      slidesPerView: 'auto',
      spaceBetween: 8,
    },
    720: {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 8,
    },
    950: {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 64,
    },
  },
});

new Swiper('.school-name-slider-content', {
  modules: [Autoplay],
  loop: false,
  centeredSlides: false,
  slidesPerView: 'auto',
  loopedSlides: 13,
  spaceBetween: 16,
  speed: 5000,
  autoplay: {
    delay: 1,
    reverseDirection: true,
    disableOnInteraction: false,
  },
});

const counterAnim = (
  qSelector,
  start = 0,
  end,
  duration = 1000,
  thousandSeparator = '',
) => {
  const target = document.querySelector(qSelector);
  let startTimestamp = null;
  const step = (timestamp) => {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress = Math.min((timestamp - startTimestamp) / duration, 1);
    let newText = Math.floor(progress * (end - start) + start)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
    if (document.dir !== 'ltr') {
      newText = newText.toLocalizedDigits();
    }
    target.innerText = newText;
    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  };
  window.requestAnimationFrame(step);
};

window.addEventListener('DOMContentLoaded', () => {
  counterAnim(
    '#counter-1',
    0,
    window['home_page_stats']['students_count'],
    2000,
    document.dir === 'ltr' ? ',' : '٬',
  );

  counterAnim(
    '#counter-2',
    0,
    window['home_page_stats']['teachers_count'],
    3000,
    document.dir === 'ltr' ? ',' : '٬',
  );

  counterAnim(
    '#counter-3',
    0,
    window['home_page_stats']['class_hours'],
    4000,
    document.dir === 'ltr' ? ',' : '٬',
  );

  counterAnim(
    '#counter-4',
    0,
    window['home_page_stats']['submissions_count'],
    5000,
    document.dir === 'ltr' ? ',' : '٬',
  );
});
